import Cache, {CACHE_TIME_4_HOUR} from 'src/Cache/Cache';
import YouInvest, {CONFIGURED_SERVICE_REBRANDED_HEADER_FOOTER} from './YouInvest';
import axios from 'axios';
import * as Sentry from '@sentry/nextjs';

export const HEADER_FOOTER_REBRANDED_KEY = 'rebrandedHeaderFooter';

export default class Drupal {

    static async getFavouriteFundsList(sedol) {
        const response = await axios({
            method: 'GET',
            url: `${process.env.YOUINVEST_BASE_URL}/fundslist/ajax/${sedol}`,
            headers: YouInvest.getTradingRequestHeaders()
        })
        return response.data;
    }

    static async inFavouriteFundsList(sedol) {
        const apiResponse = await this.getFavouriteFundsList(sedol);

        return apiResponse ? true : false;
    }

    
    static async getDrupalNavigation(newNav = false) {
        let isRebranded = newNav ? true : false;

        try { 
            if (!isRebranded) {
                const settings = await YouInvest.getSettings();
                isRebranded = YouInvest.getConfiguredServiceAllowed(
                    CONFIGURED_SERVICE_REBRANDED_HEADER_FOOTER,
                    settings
                );
            }            
        } catch (e) {
            Sentry.captureException(e);
        }        

        try {
            const cache = new Cache; 
            const key = `ssdrupal_navigation_v1${(isRebranded) ? '_rebranded' : ''}`;
            let navigation = cache.getItem(key);
    
            if (navigation) {
                navigation[HEADER_FOOTER_REBRANDED_KEY] = isRebranded;
                return navigation;
            }
            const action = (!isRebranded) ? `/api/cms/navigations` : `/api/cms/navigations-v2`;

            const response = await axios({
                method: 'GET',
                url: `${process.env.YOUINVEST_BASE_URL}${action}`,
                headers: YouInvest.getTradingRequestHeaders()
            });

            if (response.data && response.data.data) {  
                const drupalNavigation = response.data.data; 
                drupalNavigation[HEADER_FOOTER_REBRANDED_KEY] = isRebranded;
                cache.setItem(key, drupalNavigation, CACHE_TIME_4_HOUR);
                return drupalNavigation;
            }
        } catch(e) {
            Sentry.captureException(e);
        }

        return null;
    }

}